<template>
    <HeadlessListbox v-slot="{ open }" class="relative" as="div">
        <HeadlessListboxButton
            :disabled="isDisabled ? true : false"
            :class="isDisabled ? 'opacity-30 cursor-default' : 'opacity-100'"
            class="py-1 px-2 rounded-full bg-gray-800 text-gray-100 flex items-center"
            as="button"
        >
            <span class="mx-1 text-title-sm font-bold">{{ properValue(rangeValue) }}</span>
            <Icon :name="open ? 'tabler:chevron-up' : 'tabler:chevron-down'" size="16px" />
        </HeadlessListboxButton>
        <HeadlessListboxOptions
            class="absolute mt-2 bg-gray-900 min-w-32 p-2 rounded-2xl flex flex-col space-y-2 z-10 h-[230px]"
            as="ul"
        >
            <HeadlessListboxOption
                as="li"
                v-for="(currencyItem, currencyIndex) in enterprisePricePackages"
                @click="changePricePackage(currencyItem, currencyIndex)"
                :key="`currency-item-${currencyIndex}`"
                :value="currencyItem.credit"
                :class="rangeValue  == currencyItem.credit_per_month as any ? 'text-brand-300' : 'text-gray-100'"
                class="font-medium transition-all p-2 hover:bg-gray-850 space-x-1 cursor-pointer rounded-lg flex items-center"
            >
                <p class="text-body-lg leading-0">{{ properValue(currencyItem.credit) }}</p>
            </HeadlessListboxOption>
        </HeadlessListboxOptions>
    </HeadlessListbox>
</template>

<script setup lang="ts">
import { useUserStore } from "~/store/global/user.store";
import type { IPricingPackage } from "../types";

const { enterprisePricePackages } = storeToRefs(usePricingStore());
const { userData } = storeToRefs(useUserStore());
const auth = useAuth();
interface IDropdownItem {
    symbol: string;
    currency: string;
    amount: number;
    amount_per_month: number;
    credit: number;
    credit_per_month: number;
    plan_transition_type: string;
}
interface IProps {
    rangeValue: number;
    cycle: string;
    isYearly: boolean;
    isDisabled?: boolean;
}
const props = withDefaults(defineProps<IProps>(), {
    isDisabled: false,
});

const emit = defineEmits(["emitData"]);
const properValue = (payload: any) => {
    if (payload === 2400 || payload === 200) return 200;
    if (payload === 12000 || payload === 1000) return "1k";
    if (payload === 24000 || payload === 2000) return "2k";
    if (payload === 48000 || payload === 4000) return "4k";
    if (payload === 120000 || payload === 10000) return "10k";
};
const changePricePackage = (payload: IPricingPackage, currencyIndex: number) => {
    emit("emitData", payload, currencyIndex);
};

const currentValue = defineModel<string>();
</script>
